import { SORT_DETAILS } from "../components/dynamicTable/DynamicTable";
import { SORT_DIRECTION } from "../utils/Types";

const toComparable = (raw: any): string | number => {
  if (Array.isArray(raw)) {
    if (raw.length === 0) return "";
    const numeric = raw.map(Number);
    if (numeric.every((n) => !Number.isNaN(n))) return Math.min(...numeric);
    return raw.join(",");
  }
  if (raw && typeof raw === "object") return raw.value ?? "";
  return raw;
};

export function listDynamicSort(list: Array<any>, sortDetails: SORT_DETAILS) {
  const { sortKey, sortDirection = SORT_DIRECTION.ASCENDING } = sortDetails;

  if (sortKey) {
    const multiplier = sortDirection === SORT_DIRECTION.ASCENDING ? 1 : -1;
    return list.sort((a, b) => {
      const compareValA = toComparable(a[sortKey] ?? "");
      const compareValB = toComparable(b[sortKey] ?? "");

      if (typeof compareValA === "string" && typeof compareValB === "string") {
        return compareValA.localeCompare(compareValB) * multiplier;
      }

      if (typeof compareValA !== typeof compareValB) {
        return (
          String(compareValA).localeCompare(String(compareValB)) * multiplier
        );
      }

      if (compareValA > compareValB) {
        return multiplier;
      }
      if (compareValA < compareValB) {
        return -multiplier;
      }

      return 0;
    });
  }

  return list;
}
